document.addEventListener('click', function (e) {
    const btn = e.target.closest('.btn-copy-promo-code');

    if (!btn) return;

    const banner = btn.closest('.promocode-banner');
    const promoCodeEl = banner.querySelector('.promo-code');

    if (!promoCodeEl) return;

    const promoCode = promoCodeEl.textContent.trim();
    const copiedText = btn.dataset.copied || 'Copied';
    const defaultText = btn.dataset.defaultText || btn.textContent.trim();

    btn.dataset.defaultText = defaultText;

    navigator.clipboard.writeText(promoCode).then(() => {
        btn.classList.add('is-copied');

        const textNode = Array.from(btn.childNodes).find(
            node => node.nodeType === Node.TEXT_NODE && node.textContent.trim()
        );

        if (textNode) {
            textNode.textContent = ` ${copiedText} `;
        }

        setTimeout(() => {
            btn.classList.remove('is-copied');

            if (textNode) {
                textNode.textContent = ` ${defaultText} `;
            }
        }, 1600);
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const promoEl = document.querySelector('.js-promo-code');
    if (!promoEl) return;

    const promoCode = sessionStorage.getItem('stadami_promo_code');

    if (promoCode) {
        promoEl.textContent = promoCode;
        sessionStorage.removeItem('stadami_promo_code');
    } else {
        promoEl.textContent = 'No code available';
    }
});